import * as actionTypes from 'redux/actions'

const initialState = {
  campaignSearch: '',
  packageId: 'all',
  userType: 'both',
  managePackageId: 'all',
  manageSearch: '',
  brandsFilter: 'all',
  manageStartDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
  manageEndDate: new Date(new Date().setMonth(new Date().getMonth() + 2)),
  statusId: 'all',
  activeVideoPlatform: 'all',
  activeVideoPackage: 'all',
  activeVideoType: 'all',
  activeVideoSearch: '',
  activeVideoStartDate: new Date(
    new Date().setMonth(new Date().getMonth() - 1)
  ),
  activeVideoEndDate: new Date(new Date().setMonth(new Date().getMonth() + 1))
}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CAMPAIGN_SEARCH: {
      return {
        ...state,
        campaignSearch: action.payload
      }
    }

    case actionTypes.SET_PACKAGE_FILTER: {
      return {
        ...state,
        packageId: action.payload
      }
    }
    case actionTypes.SET_MANAGE_PACKAGE_FILTER: {
      return {
        ...state,
        managePackageId: action.payload
      }
    }
    case actionTypes.SET_STATUS_FILTER: {
      return {
        ...state,
        statusId: action.payload
      }
    }
    case actionTypes.SET_MANAGE_BRANDS_SEARCH: {
      return {
        ...state,
        brandsFilter: action.payload
      }
    }
    case actionTypes.SET_MANAGE_SEARCH: {
      return {
        ...state,
        manageSearch: action.payload
      }
    }
    case actionTypes.SET_COMPANY_SEARCH: {
      return {
        ...state,
        companySearch: action.payload
      }
    }
    case actionTypes.SET_MANAGE_START_DATE: {
      return {
        ...state,
        manageStartDate: action.payload
      }
    }
    case actionTypes.SET_MANAGE_END_DATE: {
      return {
        ...state,
        manageEndDate: action.payload
      }
    }
    case actionTypes.SET_ACTIVE_VIDEO_PLATFORM: {
      return {
        ...state,
        activeVideoPlatform: action.payload
      }
    }
    case actionTypes.SET_ACTIVE_VIDEO_PACKAGE: {
      return {
        ...state,
        activeVideoPackage: action.payload
      }
    }
    case actionTypes.SET_ACTIVE_VIDEO_SEARCH: {
      return {
        ...state,
        activeVideoSearch: action.payload
      }
    }
    case actionTypes.SET_ACTIVE_VIDEO_TYPE: {
      return {
        ...state,
        activeVideoType: action.payload
      }
    }
    case actionTypes.SET_ACTIVE_VIDEO_START_DATE: {
      return {
        ...state,
        activeVideoStartDate: action.payload
      }
    }
    case actionTypes.SET_ACTIVE_VIDEO_END_DATE: {
      return {
        ...state,
        activeVideoEndDate: action.payload
      }
    }
    case actionTypes.SET_USER_TYPE_FILTER: {
      return {
        ...state,
        userType: action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default dashboardReducer
